import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const dsIntegrationsService = new CachedService(entities.Orderadmin_DeliveryServices_Entity_Integration, '/delivery-services/integrations', HALApiService, createItemsData)
